import { useMemo } from "react";
import { useIntl } from "react-intl";
import commonMessages from "../../../shared/lib/messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const translations = useMemo(() => {
    return {
      defaultError: formatMessage(commonMessages.defaultError),
    };
  }, [formatMessage]);

  return translations;
};

export default useTranslations;
